import React from 'react'
import { useTranslation } from 'react-i18next'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import GoldButton from 'components/ui-kit/GoldButton/index'
import Loader from 'components/ui-kit/Loader/index'
import { LOADER_HANDLER_TYPES } from 'constants/index'

const ROW =
  'mb-3 flex items-start justify-between gap-4 text-sm normal-case'

const WithdrawConfirmModal = ({
  amount,
  currencyName,
  address,
  loading,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation()

  return (
    <CommonPopup
      classes='!z-[2010]'
      modalDialogClass='!max-w-[480px]'
      modalCloseHandler={onCancel}
    >
      <h3 className='mb-2 text-lg font-bold uppercase text-white'>{t('confirmWithdrawal')}</h3>
      <p className='mb-4 text-sm font-normal normal-case leading-5 text-[var(--gray-40)]'>
        {t('confirmWithdrawalHint')}
      </p>
      <div className='rounded-[0.625rem] bg-[var(--gray-80)] p-4'>
        <div className={ROW}>
          <span className='text-[var(--gray-40)]'>{t('withdrawalAmountLabel')}</span>
          <span className='text-right font-medium text-white'>{amount} {currencyName}</span>
        </div>
        <div className={`${ROW} mb-0`}>
          <span className='shrink-0 text-[var(--gray-40)]'>{t('withdrawalAddressLabel')}</span>
          <span className='break-all text-right font-medium text-white'>{address}</span>
        </div>
      </div>
      <div className='mt-5 flex gap-3'>
        <GoldButton type='button' onClick={onCancel} className='!bg-none !bg-[var(--gray-80)]' disabled={loading}>
          {t('cancel')}
        </GoldButton>
        <GoldButton type='button' onClick={onConfirm} disabled={loading}>
          {loading
            ? <Loader variant={LOADER_HANDLER_TYPES.submit} />
            : t('confirmSend')}
        </GoldButton>
      </div>
    </CommonPopup>
  )
}

export default WithdrawConfirmModal
